export default class FilterBar {
  constructor() {
    this.toggleButton = document.querySelector(
      '.js-filter-bar-custom-select-toggle',
    )
    this.checkboxList = document.querySelector('.js-filter-bar-custom-select')

    if (this.toggleButton && this.checkboxList) {
      this.init()
    }
  }

  init() {
    const checkboxes = this.checkboxList.querySelectorAll(
      'input[type="checkbox"]',
    )
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.updateButtonLabel.bind(this))
    })

    this.buttonSpan = this.toggleButton.querySelector('span')
    this.defaultLabel =
      this.toggleButton.querySelector('.default-label').textContent

    this.toggleButton.addEventListener(
      'click',
      this.handleToggleClick.bind(this),
    )

    document.addEventListener('keydown', this.handleKeydown.bind(this))
    document.addEventListener('mousedown', this.handleMousedown.bind(this))
    document.addEventListener('keydown', this.handleDocumentKeydown.bind(this))

    this.updateButtonLabel()
  }

  openCheckboxList() {
    this.checkboxList.classList.add('show')
    this.toggleButton.setAttribute('aria-expanded', 'true')

    const firstCheckbox = this.checkboxList.querySelector(
      'input[type="checkbox"]',
    )
    if (firstCheckbox) {
      firstCheckbox.focus()
    }
  }

  closeCheckboxList() {
    this.checkboxList.classList.remove('show')
    this.toggleButton.setAttribute('aria-expanded', 'false')
  }

  updateButtonLabel() {
    const checkedCheckboxes = this.checkboxList.querySelectorAll(
      'input[type="checkbox"]:checked',
    )
    const selectedCategories = Array.from(checkedCheckboxes).map(
      (checkbox) => checkbox.nextElementSibling.textContent,
    )
    const buttonLabel = selectedCategories.join(', ')

    this.buttonSpan.textContent = buttonLabel || this.defaultLabel
  }

  handleToggleClick(event) {
    event.preventDefault()
    const expanded = this.toggleButton.getAttribute('aria-expanded') === 'true'

    if (expanded) {
      this.closeCheckboxList()
    } else {
      this.openCheckboxList()
    }
  }

  handleKeydown(event) {
    if (
      event.key === 'Escape' &&
      this.toggleButton.getAttribute('aria-expanded') === 'true'
    ) {
      this.closeCheckboxList()
    }
  }

  handleMousedown(event) {
    if (
      !this.checkboxList.contains(event.target) &&
      !this.toggleButton.contains(event.target)
    ) {
      this.closeCheckboxList()
    }
  }

  handleDocumentKeydown(event) {
    if (
      (event.key === 'Tab' || (event.key === 'Shift' && event.key === 'Tab')) &&
      this.toggleButton.getAttribute('aria-expanded') === 'true'
    ) {
      setTimeout(() => {
        if (
          !this.checkboxList.contains(document.activeElement) &&
          !this.toggleButton.contains(document.activeElement)
        ) {
          this.closeCheckboxList()
        }
      }, 0)
    }
  }
}
